export default __webpack_public_path__ + "images/ad2e29ae13b778704b970766795ff659.svg";